module.exports = __webpack_public_path__ + "static/img/WeHaveTheRightApproach_Mobile.82bb3d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/WeHaveTheRightApproach_Mobile.svg
// module id = mLYQ
// module chunks = 1